(() => {
  document.addEventListener("DOMContentLoaded", function () {
    openDropdownsOnMouseover();
    addMessageToButtons();
  });

  function openDropdownsOnMouseover() {
    if (window.innerWidth < 768) return;
    const detailsEl = document.querySelectorAll("details");
    detailsEl.forEach((el) => {
      el.addEventListener("mouseover", function () {
        this.setAttribute("open", true);
      });
      el.addEventListener("mouseleave", function () {
        this.removeAttribute("open");
      });
    });
  }

  // Script to add a message at the top of buttons in template "perimenopausia-360"
  function addMessageToButtons() {
    const template = document.querySelector(
      "html[data-template='perimenopausia-360']"
    );

    if (template) {
      const buttons = document.querySelectorAll("main .button");
      
      // Get the message from the data attribute
      const message = template.dataset.perimenopausiaMessage || 'Obtén tu descuento único antes del 28';

      buttons.forEach((button) => {
        // Add launch message before button
        button.insertAdjacentHTML(
          "beforebegin",
          `<div class="message">${message}</div>`
        );

        // Add checkbox and terms message before button
        const checkboxId = `terms-checkbox-${Math.random()
          .toString(36)
          .substr(2, 9)}`;
        button.insertAdjacentHTML(
          "beforebegin",
          `<div class="terms-container">
            <label class="terms-checkbox-label" for="${checkboxId}">
              <input type="checkbox" id="${checkboxId}" class="terms-checkbox" required>
              <span class="checkbox-custom"></span>
              <span class="terms-text">
                Primero acepta los <a href="/pages/perimenopausia-360-terminos-y-condiciones" target="_blank">Términos y Condiciones</a>, 
                la <a href="/pages/perimenopausia-360-politica-de-reembolso" target="_blank">Política de Reembolso</a> 
                y la <a href="/pages/perimenopausia-360-politica-de-privacidad" target="_blank">Política de Privacidad</a>
              </span>
            </label>
          </div>`
        );

        // Get the checkbox element
        const checkbox = document.getElementById(checkboxId);

        // Initially disable the button
        button.disabled = true;
        button.style.opacity = "0.6";
        button.style.cursor = "not-allowed";

        // Add event listener to checkbox
        checkbox.addEventListener("change", function () {
          if (this.checked) {
            button.disabled = false;
            button.style.opacity = "1";
            button.style.cursor = "pointer";
            // Remove error highlighting if it was applied
            this.closest(".terms-container").classList.remove("error");
          } else {
            button.disabled = true;
            button.style.opacity = "0.6";
            button.style.cursor = "not-allowed";
          }
        });

        // Add click event listener to button for validation
        button.addEventListener("click", function (e) {
          if (!checkbox.checked) {
            e.preventDefault();
            e.stopPropagation();

            // Highlight the checkbox container to show error
            const termsContainer = checkbox.closest(".terms-container");
            termsContainer.classList.add("error");

            // Add a temporary shake animation
            termsContainer.style.animation = "shake 0.5s ease-in-out";
            setTimeout(() => {
              termsContainer.style.animation = "";
            }, 500);

            // Scroll to the checkbox if it's not visible
            checkbox.scrollIntoView({ behavior: "smooth", block: "center" });

            return false;
          }
        });
      });

      // Add CSS for the checkbox styling and error state
      const style = document.createElement("style");
      style.textContent = `
        .terms-container {
          margin-top: 10px;
          padding: 10px;
          border-radius: 6px;
          transition: all 0.3s ease;
          background-color: #f8f9fa;
          border: 1px solid #e9ecef;
          max-width: 400px;
        }
        
        .terms-container.error {
          background-color: #ffe6e6;
          border: 2px solid #ff4444;
          animation: shake 0.5s ease-in-out;
        }
        
        .terms-checkbox-label {
          display: flex;
          align-items: flex-start;
          cursor: pointer;
          font-size: 13px;
          line-height: 1.4;
          color: #333;
        }
        
        .terms-checkbox {
          position: absolute;
          opacity: 0;
          pointer-events: none;
        }
        
        .checkbox-custom {
          width: 16px;
          height: 16px;
          border: 2px solid #6c757d;
          border-radius: 3px;
          margin-right: 8px;
          margin-top: 1px;
          flex-shrink: 0;
          position: relative;
          transition: all 0.3s ease;
          background-color: white;
        }
        
        .terms-checkbox:checked + .checkbox-custom {
          background-color: #007bff;
          border-color: #007bff;
        }
        
        .terms-checkbox:checked + .checkbox-custom::after {
          content: '✓';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 12px;
          font-weight: bold;
        }
        
        .terms-text {
          flex: 1;
          font-weight: 400;
        }
        
        .terms-checkbox-label a {
          color: #007bff;
          text-decoration: underline;
          font-weight: 500;
        }
        
        .terms-checkbox-label a:hover {
          color: #0056b3;
          text-decoration: none;
        }
        
        .terms-checkbox-label:hover .checkbox-custom {
          border-color: #007bff;
        }
        
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
      `;
      document.head.appendChild(style);
    }
  }
})();
